import React, {useEffect, useState} from "react";
import {AdditionalSellUnit} from "../../../@types/stores/menu";
import {useTranslation} from "react-i18next";
import {ReactComponent as IconCheck} from "../../../assets/icons/check.svg";
import {getCurrency} from "../../../helpers/ApiHelper";

export interface SellUnitsGroupProps {
    sellUnits: AdditionalSellUnit[];
    onChange: (sellUnit: AdditionalSellUnit) => void;
    selected: AdditionalSellUnit;
}

const SellUnitsGroup = ({sellUnits, onChange, selected}: SellUnitsGroupProps) => {
    const [t] = useTranslation();

    const [additionalSellUnit, setAdditionalSellUnit] = useState<AdditionalSellUnit>(selected);

    useEffect(() => {
        if (selected?.price !== additionalSellUnit?.price) {
            setAdditionalSellUnit(selected);
        }
    }, [selected]);

    const changeSellUnit = (sellUnit: AdditionalSellUnit) => {
        if (sellUnit.price === additionalSellUnit?.price) {
            return;
        }

        onChange(sellUnit);
    }

    return <div className="SellUnitsGroup">
        <div className="text">
            {t("additionalSellUnits")}
        </div>
        <div>
            <div className="blocks">
                {sellUnits.map((s: AdditionalSellUnit, i: number) =>
                    <div key={`sellUnit_${s.name}`}
                         className={`block ${additionalSellUnit?.price === s.price ? "active" : ""}`}
                         onClick={() => changeSellUnit(s)}>
                        {additionalSellUnit?.price === s.price
                            ? <IconCheck className="check"/>
                            : null
                        }
                        <div className="text">
                            <div className="title">
                                {s.name}
                            </div>
                            {s.price
                                ? <div className="price">
                                    + {s.price.toFixed(2)} {getCurrency()}
                                </div>
                                : null
                            }
                        </div>
                    </div>
                )}
            </div>
        </div>
    </div>
}

export default SellUnitsGroup;
